export default {
  baseUrl:
    process.env.REACT_APP_S3_URL || 'https://s3.us-east-1.amazonaws.com/',
  defaultBucket: process.env.REACT_APP_S3_RESERVATIONS_BUCKET
};
